import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import DetailsModalTableDirectCost from './activity-details-modals/details-modal-Table-direct-cost';

const DetailsModelTableWrapper = ({
  type,
  subtotal,
  TotalCost,
  children,
  tableData,
  hideDetails,
}) => {
  const labels = hideDetails
    ? ['', 'Total']
    : ['', 'Labor', 'Material', 'Equipment', 'Subcontractor', 'Other Cost', 'Total'];

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>Sub Total:</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>${subtotal}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>Total {type} Cost:</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>${TotalCost}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            {labels.map((label, i) => (
              <TableCell key={i} sx={{ fontWeight: 'bold' }}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Direct Cost */}
          <DetailsModalTableDirectCost tableData={tableData} hideDetails={hideDetails} />

          {children}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailsModelTableWrapper;
